// Generated from California official incorporated cities dataset.
// Source: https://data.cnra.ca.gov/dataset/california-incorporated-cities
// CALIFORNIA_CITIES is overridden by local business city list from cities_202605131659.csv.

// come from database
export const CALIFORNIA_CITIES = [
  "Agoura Hills",
  "Alhambra",
  "Aliso Viejo",
  "Altadena",
  "Altaloma",
  "Anaheim",
  "Anaheim Hills",
  "Arcadia",
  "Artesia",
  "Azusa",
  "Baldwin Park",
  "Beaumont",
  "Bellflower",
  "Beverly Hills",
  "Bloomington",
  "Bradbury",
  "Bradbury Cyn",
  "Brea",
  "Buena Park",
  "Burbank",
  "Calabasas",
  "Camarillo",
  "Canoga Park",
  "Carlsbad",
  "Carson",
  "Century City",
  "Cerritos",
  "Chatsworth",
  "Chinatown",
  "Chino",
  "Chino Hills",
  "City of Industry",
  "Claremont",
  "Commerce",
  "Compton",
  "Corona",
  "Corona Del Mar",
  "Costa Mesa",
  "Coto De Caza",
  "Covina",
  "Culver City",
  "Cypress",
  "Dana Point",
  "Diamond Bar",
  "Dove Canyon",
  "Downey",
  "Duarte",
  "Eagle Rock",
  "Eastvale",
  "El Monte",
  "El Segundo",
  "El Sereno",
  "Encinitas",
  "Encino",
  "Fontana",
  "Foothill Ranch",
  "Fountain Valley",
  "Fullerton",
  "Garden Grove",
  "Gardena",
  "Glendale",
  "Glendora",
  "Granada Hills",
  "Hacienda Heights",
  "Hacienda Hts",
  "Hawaiian Gardens",
  "Hemet",
  "Hesperia",
  "Highland",
  "Hollywood",
  "Huntington Beach",
  "Inglewood",
  "Irvine",
  "Irwindale",
  "Jurupa Valley",
  "LA",
  "La Canada",
  "La Crescenta",
  "La Habra",
  "La Mirada",
  "La Palma",
  "La Puente",
  "La Verne",
  "Ladera Ranch",
  "Laguna Beach",
  "Laguna Hills",
  "Laguna Niguel",
  "Laguna Woods",
  "Lake Elsinore",
  "Lake Forest",
  "Lakewood",
  "Lancaster",
  "Las Flores",
  "Lax Airport",
  "Lincoln Heights",
  "Loma Linda",
  "Lomita",
  "Long Beach",
  "Los Alamitos",
  "Los Angeles",
  "Los Angeles downtown LA",
  "Malibu",
  "Manhattan Beach",
  "Marina Del Rey",
  "Menifee",
  "Mira Loma",
  "Mission Hills",
  "Mission Viejo",
  "Monrovia",
  "Montclair",
  "Montebello",
  "Monterey Park",
  "Montrose",
  "Moorpark",
  "Moreno Valley",
  "Murrieta",
  "Newport Beach",
  "Newport Coast",
  "Norco",
  "North Hollywood",
  "Northridge",
  "Norwalk",
  "Oceanside",
  "Ontario",
  "Orange",
  "Pacific Palisades",
  "Palm Springs",
  "Palos Verdes",
  "Palos Verdes Estates",
  "Panorama City",
  "Paramount",
  "Pasadena",
  "Perris",
  "Phillips Ranch",
  "Pico Rivera",
  "Placentia",
  "Pomona",
  "Porter Ranch",
  "Pve",
  "Rancho Cucamonga",
  "Rancho Mission Viejo",
  "Rancho Palos Verdes",
  "Rancho Santa Margarita",
  "Redlands",
  "Redondo Beach",
  "Reseda",
  "Rialto",
  "Riverside City",
  "Rolling Hills",
  "Rosemead",
  "Rowland Heights",
  "Rowland Hts",
  "San Bernardino",
  "San Clemente",
  "San Diego Border",
  "San Diego Downtown",
  "San Diego UCSD",
  "San Dimas",
  "San Gabriel",
  "San Joaquin Hills",
  "San Juan Capistrano",
  "San Marino",
  "San Pedro",
  "Santa Ana",
  "Santa Barbara",
  "Santa Clarita",
  "Santa Fe Springs",
  "Santa Margarita",
  "Santa Monica",
  "Seal Beach",
  "Sherman Oaks",
  "Sierra Madre",
  "Simi Valley",
  "South Pasadena",
  "Stanton",
  "Studio City",
  "Sun Valley",
  "Sylmar",
  "Temecula",
  "Temple City",
  "Thousand Oaks",
  "Topanga",
  "Torrance",
  "Trabuco Canyon",
  "Tujunga",
  "Tustin",
  "UCLA",
  "Universal City",
  "Upland",
  "USC",
  "Valencia",
  "Van Nuys",
  "Vernon",
  "Victorville",
  "Villa Park",
  "Walnut",
  "West Covina",
  "West Hills",
  "West L.A",
  "West L.A.",
  "Westlake Village",
  "Westminster",
  "Westwood",
  "Whittier",
  "Winchester",
  "Woodland Hills",
  "Yorba Linda",
] as const;
